let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ppIg")).then(() => parcelRequire('83cMO'));